function componentsRepositionHeader() {
  // add registration link to top nav-bar desktop
  registrationLink();

  // add top banner = message about ongoing benefits / promotions on e-shop
  if (typeof headerInfoBanner !== 'undefined' && headerInfoBanner) {
    setInfoBannerInHeader();
  }
  // add mobile navigation
  addSecondaryMobileNavigation();
}

function registrationLink() {
  if ($(".top-navigation-bar").length > 0) {
    var registrationLink;
    var registration;
    switch(lang) {
      case 'sk':
        registrationLink = '/registracia/';
        registration = 'Registrácia';
        break;
      case 'hu':
        registrationLink = '/regisztracio/';
        registration = 'Új regisztráció';
        break;
      case 'cs':
        registrationLink = '/registrace/';
        registration = 'Registrace';
        break;
      case 'ro':
        registrationLink = '/inregistrare/';
        registration = 'Înregistrare';
        break;
      case 'bg':
        registrationLink = '/registration/';
        registration = 'Регистриране';
        break;
      case 'hr':
        registrationLink = '/registration/';
        registration = 'Registracija';
        break;
      case 'sl':
        registrationLink = '/registration/';
        registration = 'Registracija';
        break;
      case 'uk':
        registrationLink = '/registration/';
        registration = 'Registrácia';
        break;
      default:
        return;
    }

    $('.top-nav-button.top-nav-button-login.primary.login.toggle-window').before('<a href="' + registrationLink + '" class="top-registration-button"><span>'+ registration +'</span></a>');
  }
}

function addSecondaryMobileNavigation() {
  var navList = $(".navigation-in > ul");
  var navLogin = $(".navigation-in > ul.navigationActions > li:not(.ext)");
  $(".header-top").append("<div class='navigation-secondary'><ul></ul></div>");
  var navSecondary = $(".navigation-secondary ul");
  // add to navList only those categories that are visible in PC menu and login
  navList.find("> li:visible").add(navList.find(navLogin)).each(function () {
    var inst = $(this);
    var link = inst.html();
    navSecondary.append("<li>" + link + "</li>");
  });
  navSecondary.find("li > ul").remove();
  navSecondary.find(".submenu-arrow").remove();
}

// for correct functioning of setInfoBannerInHeader function, it is necessary to insert this code into the shoptet administration
/*
<script>
var headerInfoBanner = false; // turn on, turn off
var headerInfoBannerLinkActive = true;
var headerInfoBannerLink = "matrace"; // link
var headerInfoBannerText = 'MATRACE SKLADOM ODOŠLEME DO 24 HODÍN.';
var headerInfoBannerBG = "#064d5f";
var headerInfoBannerTextColor = "#ffffff";
var addProductToBasketStyle = true;
</script>
*/

function setInfoBannerInHeader() {
  if (headerInfoBannerLinkActive) {
    var headerInfoBannerTextCustom =
      '<a href="/' +
      headerInfoBannerLink +
      '/"><span> ' +
      headerInfoBannerText +
      " </span></a>";
  } else {
    var headerInfoBannerTextCustom =
      "<span> " + headerInfoBannerText + " </span>";
  }

  var headerInfoBannerTemplate = `
		<div class="header-info-banner">
			<div class="container">
				<div class="header-info-banner__content">
					<div class="header-info-banner__left-panel">
						<div class="header-info-banner__text">${headerInfoBannerTextCustom}</div>
					</div>
				</div>
			</div>
		</div>
	`;

  $(".top-navigation-bar").prepend($(headerInfoBannerTemplate));
  $("body").addClass("is-header-info-banner");

  let root = document.documentElement;

  if (headerInfoBannerBG.length > 0) {
    root.style.setProperty("--color-header-banner-info-bg", headerInfoBannerBG);
  }

  if (headerInfoBannerTextColor.length > 0) {
    root.style.setProperty(
      "--color-header-banner-info-text-color",
      headerInfoBannerTextColor
    );
  }
}
